module.exports = __webpack_public_path__ + "img/gift4-01-c11-y2.ebbc0877.png";